import * as React from 'react'
import { BillToMatchProps } from './typings'
import { BillToMatchDrawer } from './BillToMatchDrawer'
import { useDialogState } from '@user/utils/useDialogState'
import { SideDrawer } from '@sales-center/components'

import Button from '@mui/material/Button'
import { useCallback } from 'react'
import { selectBillToCreator } from '../hooks'

export const BillToMatchButton: React.FC<BillToMatchProps> = (props) => {
  const {
    state: { externalBillTo },
    styles,
    dispatch,
  } = props

  const [open, onOpen, onClose] = useDialogState()

  const matched = !!externalBillTo

  const label = matched ? 'Unmatch' : 'Match To Existing Location'

  const className = matched ? styles.unmatchButton : styles.matchButton
  const onUnmatch = useCallback(() => {
    dispatch(selectBillToCreator(undefined))
  }, [dispatch])

  return (
    <>
      <Button
        onClick={matched ? onUnmatch : onOpen}
        color="primary"
        variant="outlined"
        sx={className}
        data-test-id="billToMatchBtn"
      >
        {label}
      </Button>

      <SideDrawer
        title="Bill-to Search for Matching"
        open={open}
        onClose={onClose}
        containerBottom="116px"
      >
        <BillToMatchDrawer {...props} onClose={onClose} />
      </SideDrawer>
    </>
  )
}
BillToMatchButton.displayName = 'BillToMatchButton'
